import cl from 'classnames';
import * as React from 'react';
import styled from 'styled-components';
import { colorsV2 } from '../../../../figma/colors-v2';
import { EditorProps } from '../../../../figma/DolEditor/types';
import { ViewVocabFlowReadOnlyPlugin } from '../ViewVocabFlow/plugins/ViewVocabFlowReadOnlyPlugin';
import { BlogEditorReadOnlyWithStyles } from '../../../../figma/BlogEditor/BlogEditorReadOnlyWithStylesPlugin';
import { VocabIdeaTitleReadOnlyPlugin } from './plugins/VocabIdeaTitleReadOnlyPlugin';
import { ViewIdeaFlowReadOnlyPlugin } from '../ViewIdeaFlow/plugins/ViewIdeaFlowReadOnlyPlugin';

export interface ViewVocabIdeaEditorProps extends Omit<EditorProps, 'title'> {
  isReadOnly?: boolean;
  title?: JSX.Element | string;
  onDelete?: () => void;

  withTitleNode?: boolean;
  paragraphIndex?: number;
}

const Main = styled.div`
  background-color: ${colorsV2.white100};
  padding: 0;
  .vocab-idea-title-element {
    font-size: 24px;
    line-height: 36px;
    margin-bottom: 24px;
    font-family: noto-serif, serif;
    font-weight: 600;
    color: ${colorsV2.black100};
  }
  &.have-title {
    padding: 24px;
    background: ${colorsV2.gray5};
    border-radius: 16px;
  }
`;

export const ViewVocabIdeaEditorReadOnly: React.FC<ViewVocabIdeaEditorProps> = (
  props: ViewVocabIdeaEditorProps
) => {
  const {
    title,
    initialValue,
    isReadOnly = false,
    plugins = [],
    withTitleNode,
    audio,
    paragraphIndex,
    ...rest
  } = props;

  const defaultPlugins = React.useMemo(
    () => [
      ViewVocabFlowReadOnlyPlugin({ isReadOnly }),
      ViewIdeaFlowReadOnlyPlugin({ isReadOnly }),
      VocabIdeaTitleReadOnlyPlugin({
        haveTitle: withTitleNode,
        isReadOnly,
        enabled: withTitleNode,
        audio,
        paragraphIndex,
      }),
      ...plugins,
    ],
    [audio, isReadOnly, paragraphIndex, plugins, withTitleNode]
  );

  return (
    <Main
      className={cl('vocab-idea-editor-container', {
        'read-only': isReadOnly,
        'have-title': withTitleNode,
      })}
    >
      <BlogEditorReadOnlyWithStyles value={initialValue} plugins={defaultPlugins} {...rest} />
    </Main>
  );
};
